export default "__VITE_ASSET__DwThQVJW__"